import { render } from "./MediaSettingsPopUp.vue?vue&type=template&id=d05c5df6&scoped=true&ts=true"
import script from "./MediaSettingsPopUp.vue?vue&type=script&lang=ts"
export * from "./MediaSettingsPopUp.vue?vue&type=script&lang=ts"

import "./MediaSettingsPopUp.vue?vue&type=style&index=0&id=d05c5df6&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05c5df6"]])

export default __exports__